<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-size-100">
                <drop-down>
                    <md-button class="md-primary md-simple" >
                        <md-icon>add</md-icon>
                        {{ $t('add') }}
                    </md-button>
                    <ul class="dropdown-menu">
                        <li v-for="widget in widgetsList" :key="widget.name">
                            <a @click.prevent="addWidget(widget)">{{ $t(`widget.${widget.name}.name`) }}</a>
                        </li>
                    </ul>
                </drop-down>
            </div>
        </div>
        <div>
            <draggable v-model="widgets" handle=".handle">
                <transition-group class="md-layout">
                    <dashboard-widget-card-wings v-for="(widget, index) in widgets"
                            v-model="widgets[index]"
                            :key="'widget'+index"
                            @remove="remove(index)"
                    ></dashboard-widget-card-wings>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
  import draggable from "vuedraggable";
  import DashboardWidgetCardWings from "@/components/Dashboard/DashboardWidgetCardWings.vue";
  import {notifyErrorCustom} from "@/utils/notify-helper";
  import i18n from "@/plugins/i18n";
  export default {
    name: "DashboardWings",
    components: {DashboardWidgetCardWings,draggable},
    data(){return {
      widgets:this.loadWidgets(),
    }},
    props:{
      maxWidgetNum: {
        type:Number,
        require:true,
        default:10
      }
    },
    computed:{
      widgetsList(){ return [
        {name:'WCSActivity',ShowOptions:true,options:{}},
        {name:'SMPPActivity',fullSize:false,ShowOptions:true,options:{}},
        {name:'MessagesByGroup',fullSize:false,ShowOptions:true,options:{}},
        // {name:'ShippingSummary',ShowOptions:true,options:{}},
        // {name:'MessageStatuses',fullSize:false,ShowOptions:true,options:{}},
        // {name:'TrafficSending',fullSize:false,ShowOptions:true,options:{}},
        // {name:'TrafficProviders',fullSize:false,ShowOptions:true,options:{}},
        // {name:'SendingProviders',fullSize:false,ShowOptions:true,options:{}},
        // {name:'ErrorsProviders',fullSize:false,ShowOptions:true,options:{}},
      ]}
    },
    methods:{
      remove(index){
        this.$delete(this.widgets,index)
      },
      loadWidgets(){
        if(localStorage.getItem('DashboardWidgetsWings')) {
          return JSON.parse(localStorage.getItem('DashboardWidgetsWings'))
        }
        return []
      },
      addWidget(widget) {
        if (this.widgets.length < this.maxWidgetNum) {
          const unique = new Date().getTime();
          widget = {...widget, ...{'id': unique}}
          this.widgets.push(widget);
        } else {
          notifyErrorCustom(i18n.tc('errors.max_widgets_num'));
        }
      }
    },
    watch:{
      widgets:{
        deep: true,
        handler(val){
          if (val){
            localStorage.setItem('DashboardWidgetsWings',JSON.stringify(val))
          }
        }
      }
    }
  }
</script>
